import React, { FunctionComponent, ReactNode } from 'react';

type DividerProps = {
  children: ReactNode;
  className?: string;
};

const Divider: FunctionComponent<DividerProps> = ({
  children,
  className = '',
}) => (
  <p
    className={`jg-text--center jg-tc__text--line-through jg-position-relative jg-text--large-regular jg-color--empress jg-space-mbn ${className}`}
    data-qa="divider"
  >
    <span className="jg-tc__text--line-through--text">{children}</span>
  </p>
);

export default Divider;
